import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Row, Form, Button } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';

const Strings = require('../../../../app/shared/Strings');
const ResetPasswordStore = require('../../stores/reset_password_store_reflux');
const ResetPasswordActions = require('../../actions/reset_password_actions');
const ValidateUtil = require('../../util/ValidateUtil');
const KeyboardUtil = require('../../util/keyboard');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import SignedOutPromoPanel from './SignedOutPromoPanel';
// import SignedOutFooter from './SignedOutFooter';

const propTypes = {
    history: PropTypes.object.isRequired,
};

const defaultProps = {};

class RequestResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.emailOnChange = this.emailOnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.requestHandler = this.requestHandler.bind(this);
        this.unsubscribes = [
            ResetPasswordStore.listen(this.onResetPasswordStoreChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onResetPasswordStoreChange(newState) {
        let updatedState = ValidateUtil.getUpdatedState(this.state.actionID, newState);
        this.setState(updatedState);
    }

    emailOnChange(e){
        this.setState({ email: e.target.value });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.requestHandler(e);
        }
    }

    requestHandler(e) {
        e.preventDefault();
        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            ResetPasswordActions.requestReset(actionID, { email: this.state.email });
        });
    }

    render() {
        return (
            <div className="fill signed-out--new">
                <div className="container rel-centered-v">
                    <div className="signedOutDual">
                        <SignedOutPromoPanel />
                        <div className="signedOutDual__form">
                            <div className="signedOutDual__formHeaderArea">
                                <h2 className="signedOutDual__formHeaderArea--header">
                                    {Strings['en'].signed_out.sign_in_new.forgot_form.REQ_RESET}
                                </h2>
                            </div>
                            <div>
                                <ErrorBox error={this.state.error} />
                                {(this.state.actionSuccess) && 
                                    <div>
                                        <SuccessBox message={this.state.successMessage} />
                                        <div className="signedOutDual__formRememberForgot margin-top-lg">
                                            <Link to='/signin'>{Strings['en'].signed_out.sign_in_new.forgot_form.SIGN_IN_LINK}</Link>
                                        </div>
                                    </div>
                                }
                                <div style={this.state.actionSuccess? {display: 'none'} : {display: 'block'}}>
                                    <Form>
                                        <Form.Group controlId="req-reset-email">
                                            <Form.Label>{Strings['en'].signed_out.sign_in_new.form.EMAIL}</Form.Label>
                                            <Form.Control
                                                type="email"
                                                aria-label={Strings['en'].signed_out.sign_in_new.form.EMAIL}
                                                onChange={this.emailOnChange}
                                                onKeyDown={this.handleKeyDown}
                                                isInvalid={ValidateUtil.isInvalid(this.state, 'email')}
                                            />
                                        </Form.Group>
                                        <div className="signedOutDual__formRememberForgot margin-top-lg">
                                            <Link to='/signin'>{Strings['en'].signed_out.sign_in_new.forgot_form.SIGN_IN_LINK}</Link>
                                        </div>
                                        <div className="signedOutDual__buttonRow margin-top-lg">
                                            <Button
                                                disabled={this.state.actionSuccess}
                                                onClick={this.requestHandler}
                                            >
                                                {Strings['en'].signed_out.sign_in_new.forgot_form.REQ}
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

RequestResetPassword.propTypes = propTypes;
RequestResetPassword.defaultProps = defaultProps;

export default withRouter(RequestResetPassword);